export default {
	html: document.documentElement,
	body: document.body,
	width: window.innerWidth,
	height: window.innerHeight,
	wp: window.__WP_VARS,
	animating: false
}
